import { useState } from "react";

import { cx } from "@/utils";
import Typography from "@components/Typography";

import { useMentionCard } from "../../../context";
import ExternalLink from "../../Body/partials/ExternalLink";
import ExpandMentions from "../partials/ExpandMentions";

import styles from "./TextBodyMobile.module.css";

const TextBodyMobile = (props: { defaultOpen: boolean }) => {
  const { mentions } = useMentionCard();
  const [expanded, setExpanded] = useState(props.defaultOpen);

  return (
    <div onClick={() => setExpanded((v) => !v)}>
      {mentions.length > 0 && <ExpandMentions open={expanded} />}
      {expanded &&
        mentions.map((m) => (
          <Typography
            variant="body-2"
            key={m.public_id}
            className={cx(styles.mention, "highlight-match")}
          >
            <span dangerouslySetInnerHTML={{ __html: m.text }} />
          </Typography>
        ))}
      {expanded && <ExternalLink />}
    </div>
  );
};

export default TextBodyMobile;
